///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq = abcsetup.rfq || {};
abcsetup.rfq.bid_requests = abcsetup.rfq.bid_requests || {};
abcsetup.rfq.bid_requests.edit = abcsetup.rfq.bid_requests.edit || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq.bid_requests.edit = {
    init: function() {
        abcsetup.setTitle('Edit RFQ Event');

        // Init the common lib
        abcsetup.rfq.bid_requests.common.init();

        // $('form').on('submit', (e) => {
        //     abcsetup.blockUI(true);
        // });

        $('#submit_bids_btn').on('click', () => {
            $('#bid_request_edit_form [name=save_type]').val('close');
            this._on_submit();
        });

        // Adjust the start_date based on value
        if ($('#start_date').val() < $('#start_date').attr('min')) {
            $('#start_date').attr('min', $('#start_date').val());
        }

        // Adjust the close_date based on value
        if ($('#close_date').val() < $('#close_date').attr('min')) {
            $('#close_date').attr('min', $('#close_date').val());
        }
    },

    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function() {
        $('#all_suppliers, #rfq_bid_type_id').trigger('change');
    },

    /**
     * _jquery.uploader
     *      An upload is complete this is the callback
     */
    uploadDone: function() {
        // Import the specified items
        if (abcsetup.uploader.uploadResult.type == 'items') {
            abcsetup.rfq.bid_requests.common.importItems(abcsetup.uploader.uploadResult.vals);
        } else {
            abcsetup.rfq.bid_requests.common.importSuppliers(abcsetup.uploader.uploadResult.vals);
        }
    },

    /**
     * Submit the bid review form.
     *
     * @private
     */
    _on_submit({saveForLater = false, convertToSolicited = false} = {}) {
        const showBidsTable = () => $('#bids-toggle :radio[value=bids]').parents('.btn').trigger('click');

        let isValid = false;
        if (convertToSolicited) {
            fieldValidate.resetValidation($('#bid_request_edit_form'));
            isValid = true;
        } else {
            isValid = true;
        }

        if (isValid) {
            showBidsTable();
            abcsetup.blockUI(true);
            $('#bid_request_edit_form').trigger('submit');
        } else {
            // The sticky header on the challenger bids table can cover the field that's in error. Scrolling up a bit to prevent this.
            window.scrollBy(0, -100);
        }
    },
}
